export default __webpack_public_path__ + "static/media/addEstimates.58f92888.png";